export default "__VITE_ASSET__JpoQI7sU__"